(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtc-home-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
 var mobile=window.matchMedia('(max-width:767px)');
 function syncVideos(root){(root||document).querySelectorAll('.dtc-home-banner-video').forEach(function(v){
  var poster=mobile.matches?v.dataset.posterMobile:v.dataset.poster;if(poster)v.poster=poster;
  var source=mobile.matches?v.dataset.videoMobile:v.dataset.videoDesktop;
  if(source&&v.getAttribute('src')!==source){
   v.pause();v.src=source;v.load();
   var media=v.closest('.dtc-home-banner-media');clearTimeout(media.dtcHideTimer);
   media.classList.remove('has-started','is-playing','controls-visible');
   media.querySelector('button').setAttribute('aria-label','Play video');
  }
 });}
 function reveal(media){if(!media.classList.contains('is-playing'))return;media.classList.add('controls-visible');clearTimeout(media.dtcHideTimer);media.dtcHideTimer=setTimeout(function(){media.classList.remove('controls-visible');},2000);}
 function state(media,on){media.classList.toggle('is-playing',on);media.querySelector('button').setAttribute('aria-label',on?'Pause video':'Play video');clearTimeout(media.dtcHideTimer);if(on){media.classList.add('has-started');reveal(media);}else media.classList.remove('controls-visible');}
 function init(root){(root||document).querySelectorAll('.dtc-home-banner-media--video').forEach(function(media){
  if(media.dataset.bound)return;media.dataset.bound='1';var video=media.querySelector('video');
  media.addEventListener('click',function(){if(video.paused)video.play().catch(function(){state(media,false);});else video.pause();});
  media.addEventListener('mousemove',function(){reveal(media);});
  media.addEventListener('mouseleave',function(){clearTimeout(media.dtcHideTimer);media.classList.remove('controls-visible');});
  media.querySelector('button').addEventListener('focus',function(){reveal(media);});
  video.addEventListener('playing',function(){state(media,true);});
  video.addEventListener('pause',function(){state(media,false);});
  video.addEventListener('ended',function(){state(media,false);});
 });syncVideos(root);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target);});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('.dtc-home-banner-media--video').forEach(function(media){clearTimeout(media.dtcHideTimer);media.querySelector('video').pause();});});
 mobile.addEventListener('change',function(){syncVideos(document);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
 var mobile=window.matchMedia('(max-width:767px)');
 function init(root){(root||document).querySelectorAll('.dtc-home-cards-slider').forEach(function(el){
   if(el.swiper)return;
   var discover=el.dataset.variant==='discover';if(!mobile.matches&&!discover)return;
   var wrap=el.closest('.dtc-home-cards');
   var count=Array.from(el.querySelectorAll('.dtc-home-card:not(.dtc-home-card--duplicate)')).filter(function(x){return getComputedStyle(x).display!=='none'}).length;
   var pagination=wrap.querySelector('.dtc-home-cards-pagination');
   wrap.querySelectorAll('.dtc-home-cards-controls button').forEach(function(button){button.onclick=function(){if(el.swiper&&el.swiper.autoplay)el.swiper.autoplay.stop();};});
   pagination.onclick=function(event){var button=event.target.closest('[data-home-slide]');if(button&&el.swiper){el.swiper.autoplay.stop();el.swiper.slideToLoop(Number(button.dataset.homeSlide));}};
   new DtcSwiper(el,{slidesPerView:mobile.matches&&discover?1:'auto',spaceBetween:discover?10:20,speed:600,watchOverflow:true,centeredSlides:mobile.matches&&!discover,loop:count>1,grabCursor:count>1,
     autoplay:count>1?{delay:3000,disableOnInteraction:true}:false,
     navigation:{prevEl:wrap.querySelector('.dtc-home-cards-prev'),nextEl:wrap.querySelector('.dtc-home-cards-next')},
     pagination:{el:pagination,type:'custom',renderCustom:function(swiper){var html='',active=swiper.realIndex%count;for(var i=0;i<count;i++){html+='<button type="button" class="swiper-pagination-bullet'+(i===active?' swiper-pagination-bullet-active':'')+'" data-home-slide="'+i+'" aria-label="Go to slide '+(i+1)+'"'+(i===active?' aria-current="true"':'')+'></button>';}return html;}}});
 });}
 function destroy(root){(root||document).querySelectorAll('.dtc-home-cards-slider').forEach(function(el){if(el.swiper)el.swiper.destroy(true,true);var wrap=el.closest('.dtc-home-cards');wrap.querySelector('.dtc-home-cards-pagination').onclick=null;wrap.querySelectorAll('.dtc-home-cards-controls button').forEach(function(button){button.onclick=null;});});}
 dtcOnSwiper(function(){init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});document.addEventListener('shopify:section:unload',function(e){destroy(e.target)});mobile.addEventListener('change',function(){destroy(document);init(document)});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
 var desktop=window.matchMedia('(min-width:768px)'),frame=0;
 function measure(){
  frame=0;
  var bar=document.getElementById('scroll-fix-add-cart');
  document.querySelectorAll('.dtc-home-hero').forEach(function(hero){
   if(!desktop.matches){hero.style.removeProperty('--hero-flow-top');return;}
   var top=Math.max(0,hero.getBoundingClientRect().top+window.scrollY);
   var value=Math.round(top*100)/100+'px';
   if(hero.style.getPropertyValue('--hero-flow-top')!==value)hero.style.setProperty('--hero-flow-top',value);
   hero.style.setProperty('--addcart-height',(bar?bar.offsetHeight:0)+'px');
  });
 }
 function schedule(){if(!frame)frame=window.requestAnimationFrame(measure);}
 if(window.ResizeObserver)new ResizeObserver(schedule).observe(document.body);
 window.addEventListener('resize',schedule);
 window.addEventListener('load',schedule);
 document.addEventListener('shopify:section:load',schedule);
 document.addEventListener('shopify:section:unload',schedule);
 if(document.fonts)document.fonts.ready.then(schedule);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else measure();
})();
dtcRegisterCarousel('.dtc-home-hero-slider',function(el){
 var root=el.closest('.dtc-home-hero'),count=el.querySelectorAll('.swiper-slide').length;
 root.querySelector('.dtc-home-hero-controls').hidden=count<2;
 root.querySelector('.dtc-home-hero-pagination').hidden=count<2;
 var scroller=root.querySelector('.dtc-home-hero-scroller'),items=Array.from(scroller.querySelectorAll('[data-home-hero-index]'));
 scroller.hidden=count<2;
 function progress(value){scroller.style.setProperty('--hero-progress',Math.max(0,Math.min(1,value)));}
 function sync(swiper){
  var current=swiper.realIndex%count;
  progress(0);
  items.forEach(function(item,index){
   var distance=(index-current+count)%count;if(distance>count/2)distance-=count;
   item.style.transform='translateY('+((distance+1)*29)+'px)';
   item.classList.toggle('is-visible',Math.abs(distance)<=1);
   item.tabIndex=Math.abs(distance)<=1?0:-1;
   if(index===current)item.setAttribute('aria-current','true');else item.removeAttribute('aria-current');
  });
 }
 function click(event){var item=event.target.closest('[data-home-hero-index]');if(item&&el.swiper)el.swiper.slideToLoop(Number(item.dataset.homeHeroIndex));}
 scroller.addEventListener('click',click);
 return {loop:count>1,speed:1000,parallax:true,grabCursor:true,preventClicks:true,preventClicksPropagation:true,autoplay:count>1?{delay:3000,disableOnInteraction:true}:false,
 navigation:{prevEl:root.querySelector('.dtc-home-hero-prev'),nextEl:root.querySelector('.dtc-home-hero-next')},
 pagination:{el:root.querySelector('.dtc-home-hero-pagination'),clickable:true},
 on:{init:sync,slideChange:sync,autoplayTimeLeft:function(swiper,time,remaining){progress(swiper.animating?0:1-remaining);},beforeDestroy:function(){scroller.removeEventListener('click',click);}}};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-media"] && !Shopify.designMode) return;
  try {
    
dtcRegisterCarousel('.dtc-home-media-slider',function(el){
  var count=el.querySelectorAll('.dtc-home-media-card:not([aria-hidden])').length;
  // PC starts between two cards; mobile centers one complete card.
  return {slidesPerView:'auto',centeredSlides:true,initialSlide:Math.max(0,Math.min(2,count-1)),spaceBetween:10,speed:600,loop:count>1,autoplay:count>1?{delay:3000,pauseOnMouseEnter:true,disableOnInteraction:false}:false,grabCursor:count>1,watchOverflow:true,breakpoints:{768:{spaceBetween:20,slidesOffsetBefore:count>2?-580:0}}};
});
document.addEventListener('shopify:section:unload',function(event){
  event.target.querySelectorAll('.dtc-home-media-slider').forEach(function(el){if(el.swiper)el.swiper.destroy(true,true);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instances = new WeakMap();

  function init(scope) {
    var CountUp = window.countUp && window.countUp.CountUp;
    if (!CountUp) return;

    (scope || document).querySelectorAll('.dtc-home-stats').forEach(function (root) {
      if (instances.has(root)) return;
      var state = { observer: null, counters: [], values: [] };
      instances.set(root, state);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      root.querySelectorAll('.dtc-home-stat-value').forEach(function (el) {
        var raw = el.textContent.trim();
        var match = raw.match(/^(\D*)([\d.,]+)(.*)$/);
        if (!match) return;
        var plain = match[2].replace(/,/g, '');
        var end = parseFloat(plain);
        if (!Number.isFinite(end)) return;
        state.values.push({ el: el, raw: raw, end: end, options: {
          startVal: 0,
          duration: 2,
          decimalPlaces: (plain.split('.')[1] || '').length,
          useGrouping: match[2].indexOf(',') > -1,
          prefix: match[1],
          suffix: match[3]
        } });
      });

      state.observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        state.observer.disconnect();
        state.values.forEach(function (value) {
          var counter = new CountUp(value.el, value.end, value.options);
          if (counter.error) { value.el.textContent = value.raw; return; }
          state.counters.push(counter);
          counter.start();
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      state.observer.observe(root.querySelector('.dtc-home-stats-grid'));
    });
  }

  function destroy(scope) {
    scope.querySelectorAll('.dtc-home-stats').forEach(function (root) {
      var state = instances.get(root);
      if (!state) return;
      if (state.observer) state.observer.disconnect();
      state.counters.forEach(function (counter) { counter.onDestroy(); });
      state.values.forEach(function (value) { value.el.textContent = value.raw; });
      instances.delete(root);
    });
  }

  function boot() {
    init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-m5-app"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wide = window.matchMedia('(min-width: 768px)');

  function build(el) {
    var section = el.closest('.dtc-m5-app');
    return {
      loop: true,
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 20,
      centeredSlides: true,
      slideToClickedSlide: true,
      autoplay: { delay: 3000, disableOnInteraction: true },
      navigation: {
        prevEl: section.querySelector('.dtc-m5-app-prev'),
        nextEl: section.querySelector('.dtc-m5-app-next'),
      },
    };
  }

  function sync(root) {
    (root || document).querySelectorAll('.dtc-m5-app-swiper').forEach(function (el) {
      if (wide.matches && !el.swiper) new DtcSwiper(el, build(el));
      else if (!wide.matches && el.swiper) el.swiper.destroy(true, true);
    });
  }

  dtcOnSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { sync(); });
    } else {
      sync();
    }
    document.addEventListener('shopify:section:load', function (event) { sync(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.dtc-m5-app-swiper').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    });
    wide.addEventListener('change', function () { sync(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-m5-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var media = window.matchMedia('(min-width:768px)');

  function paginationFor(el) {
    var pagination = el.parentElement.querySelector('.swiper-pagination');
    var count = Number(el.dataset.slideCount);
    if (!pagination || !count) return;
    pagination.onclick = function (event) {
      var button = event.target.closest('[data-m5-slide]');
      if (button && el.swiper) el.swiper.slideToLoop(Number(button.dataset.m5Slide));
    };
    return {
      el: pagination,
      type: 'custom',
      renderCustom: function (swiper) {
        var active = swiper.realIndex % count;
        var html = '';
        for (var i = 0; i < count; i++) {
          html += '<button type="button" class="swiper-pagination-bullet' + (i === active ? ' swiper-pagination-bullet-active' : '') + '" data-m5-slide="' + i + '" aria-label="Go to slide ' + (i + 1) + '"' + (i === active ? ' aria-current="true"' : '') + '></button>';
        }
        return html;
      }
    };
  }

  function init(root) {
      root.querySelectorAll('.dtc-m5-slider').forEach(function (el) {
        if (!el.isConnected) return;
        var variant = el.dataset.variant;
        var active = variant === 'compact' || !media.matches;
        if (!active) {
          if (el.swiper) el.swiper.destroy(true, true);
          return;
        }
        if (el.swiper) return;
        var wrap = el.parentElement;
        new DtcSwiper(el, {
          slidesPerView: variant === 'accessories' ? 1 : 'auto',
          spaceBetween: media.matches ? 20 : 10,
          speed: 1000,
          loop: true,
          watchOverflow: true,
          grabCursor: true,
          autoplay: { delay: 3000, disableOnInteraction: true, waitForTransition: variant !== 'compact' },
          on: {
            autoplay: function (swiper) {
              // Only Compact uses the timer that can skip a loop advance.
              if (variant === 'compact' && swiper.autoplay.running && !swiper.autoplay.paused) swiper.autoplay.resume();
            }
          },
          pagination: paginationFor(el),
          navigation: {
            prevEl: wrap.querySelector('.dtc-m5-prev'),
            nextEl: wrap.querySelector('.dtc-m5-next')
          }
        });
      });
  }

  function destroy(root) {
    root.querySelectorAll('.dtc-m5-slider').forEach(function (el) {
      if (el.swiper) el.swiper.destroy(true, true);
      var pagination = el.parentElement.querySelector('.swiper-pagination');
      if (pagination) pagination.onclick = null;
    });
  }

  dtcOnSwiper(function () {
    function load() { init(document); }
    media.addEventListener('change', function () { destroy(document); init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
    else load();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-marc-growth"] && !Shopify.designMode) return;
  try {
    
(function(){
 var selector='.dtc-marc-growth',loading;
 function script(url,ready){
  if(ready())return Promise.resolve();
  return new Promise(function(resolve,reject){
   var el=document.createElement('script');el.src=url;el.async=true;
   el.onload=function(){ready()?resolve():reject(new Error('Animation library unavailable'));};
   el.onerror=reject;document.head.appendChild(el);
  });
 }
 function libraries(root){
  if(!loading)loading=script(root.dataset.gsapUrl,function(){return !!window.gsap;}).then(function(){return script(root.dataset.scrolltriggerUrl,function(){return !!window.ScrollTrigger;});}).catch(function(error){loading=null;throw error;});
  return loading;
 }
 function mount(root){
  if(root._marcGrowth||root.dataset.growthLoading)return;
  root.dataset.growthLoading='true';
  libraries(root).then(function(){return document.fonts?document.fonts.ready:Promise.resolve();}).then(function(){
   delete root.dataset.growthLoading;if(!root.isConnected)return;
   var gsap=window.gsap,ST=window.ScrollTrigger;gsap.registerPlugin(ST);
   var mm=gsap.matchMedia();root._marcGrowth=function(){mm.revert();delete root._marcGrowth;};
   mm.add({desktop:'(min-width:768px)',mobile:'(max-width:767px)',reduce:'(prefers-reduced-motion:reduce)'},function(context){
    if(context.conditions.reduce)return;
    var stage=root.querySelector('.dtc-marc-growth-stage'),inner=root.querySelector('.dtc-marc-growth-inner');
    var title=root.querySelector('.dtc-marc-growth-title'),lines=title.querySelectorAll('.dtc-marc-growth-sweep');
    var data=root.querySelector('.dtc-marc-growth-data'),background=root.querySelector('.dtc-marc-growth-background');
    var lowerLines=Array.from(lines).slice(1);
    var geometry={},totalDuration=.90;
    var firstScale=context.conditions.mobile?27.17/20.229:120/100.432;
    function measure(){
     root.style.setProperty('--growth-stage-height',Math.max(window.innerHeight,inner.offsetHeight)+'px');
     var available=stage.clientWidth-inner.offsetLeft*2;
     var baseTop=inner.offsetTop+title.offsetTop;
     var lineHeight=lines[0].offsetHeight;
     var fontSize=parseFloat(window.getComputedStyle(title).fontSize);
     var firstWidth=lines[0].offsetWidth;
     geometry.scale=Math.min(context.conditions.mobile?20.229/19:100.432/48,available/title.offsetWidth);
     geometry.introScale=Math.min((context.conditions.mobile?42:fontSize*162.23/48)/(fontSize*geometry.scale),available/(firstWidth*geometry.scale));
     geometry.x=0;
     // Preserve the first line's visible top while scaling around its baseline.
     var introCompensation=(geometry.introScale-1)*lineHeight*geometry.scale;
     geometry.singleY=(stage.offsetHeight-lineHeight*geometry.scale*geometry.introScale)/2-baseTop+introCompensation;
     geometry.enterY=geometry.singleY+stage.offsetHeight*199/864;
     // Center the visible three-line group, including the enlarged first line.
     geometry.y=(stage.offsetHeight-title.offsetHeight*geometry.scale)/2-baseTop+(firstScale-1)*lineHeight*geometry.scale/2;
     geometry.lowerStartY=(stage.offsetHeight*556/864-baseTop-geometry.singleY+24)/geometry.scale-lines[1].offsetTop;
    }
    root.classList.add('dtc-marc-growth--animated');measure();
    var counters=[],CountUp=window.countUp&&window.countUp.CountUp;
    if(CountUp)data.querySelectorAll('.dtc-marc-growth-stat dd').forEach(function(el){
     var raw=el.textContent.trim(),match=raw.match(/^(\D*)([\d.,]+)(.*)$/);
     if(!match)return;
     var plain=match[2].replace(/,/g,''),end=parseFloat(plain);
     if(!Number.isFinite(end))return;
     var counter=new CountUp(el,end,{startVal:0,duration:2,decimalPlaces:(plain.split('.')[1]||'').length,useGrouping:match[2].indexOf(',')>-1,prefix:match[1],suffix:match[3]});
     if(counter.error){el.textContent=raw;return;}
     counters.push({el:el,raw:raw,end:end,counter:counter});
    });
    gsap.set(lines,{'--line-tint':0});
    gsap.set(lowerLines,{'--line-tint':1});
    gsap.set(title,{autoAlpha:1});gsap.set(data,{autoAlpha:0,y:30});
    gsap.set(lowerLines,{visibility:'hidden',opacity:0});
    var clock={value:0,count:0};
    var main=gsap.timeline({paused:true,defaults:{ease:'none'},onUpdate:function(){
     var time=main.time();root.dataset.growthStage=time<.14?'enter':time<.28?'intro':time<.50?'forming':time<.825?'title':'data';
     title.style.setProperty('--line-color-strength',String(1-gsap.utils.clamp(0,1,(time-.60)/.225)));
     counters.forEach(function(value){
      var number=clock.count>=1?value.end:value.counter.easingFn(clock.count,0,value.end,1);
      value.el.textContent=value.counter.formattingFn(number);
     });
    }});
    main.to(clock,{value:1,duration:totalDuration},0)
      .addLabel('headline-enter',0)
      .addLabel('headline-white',.14)
      .addLabel('headline-tint',.16)
      .addLabel('lower-enter',.28)
      .addLabel('title-form',.28)
      .addLabel('title-hold',.50)
      .addLabel('title-settle',.60)
      .addLabel('data-enter',.7125)
      .addLabel('final',.87)
      .fromTo(title,{x:0,y:function(){return geometry.enterY;},scale:function(){return geometry.scale;}},{x:0,y:function(){return geometry.singleY;},scale:function(){return geometry.scale;},duration:.14,ease:'sine.inOut',immediateRender:true},0)
      .fromTo(lines[0],{opacity:.5,scale:function(){return geometry.introScale;}},{opacity:1,scale:function(){return geometry.introScale;},duration:.14,ease:'sine.inOut',immediateRender:true},0)
      .fromTo(lines[0],{'--line-tint':0},{'--line-tint':1,duration:.07,immediateRender:false},.16)
      .fromTo(lowerLines,{y:function(){return geometry.lowerStartY;}},{y:function(){return geometry.lowerStartY;},duration:.28,immediateRender:true},0)
      .set(lowerLines,{visibility:'visible',immediateRender:false},.28)
      // The headline, incoming lines and background share the same motion window.
      .fromTo(title,{x:0,y:function(){return geometry.singleY;},scale:function(){return geometry.scale;}},{x:0,y:function(){return geometry.y;},scale:function(){return geometry.scale;},duration:.22,ease:'sine.inOut',immediateRender:false},.28)
      .fromTo(lines[0],{scale:function(){return geometry.introScale;}},{scale:firstScale,duration:.22,ease:'sine.inOut',immediateRender:false},.28)
      .fromTo(lowerLines,{y:function(){return geometry.lowerStartY;},opacity:0},{y:0,opacity:1,duration:.22,ease:'sine.inOut',immediateRender:false},.28)
      .fromTo(background,{autoAlpha:1},{autoAlpha:0,duration:.22,ease:'sine.inOut',immediateRender:false},.28)
      .fromTo(lines[0],{scale:firstScale},{scale:1,duration:.225,ease:'sine.inOut',immediateRender:false},.60)
      .fromTo(title,{x:0,y:function(){return geometry.y;},scale:function(){return geometry.scale;}},{x:0,y:0,scale:1,duration:.225,ease:'sine.inOut',immediateRender:false},.60)
      .fromTo(data,{autoAlpha:0,y:30},{autoAlpha:1,y:0,duration:.12,ease:'sine.inOut',immediateRender:false},.7125)
      .fromTo(clock,{count:0},{count:1,duration:.12,immediateRender:false},.7125);
    var scrollFactor=context.conditions.mobile?3.6:4.2;
    var entranceDuration=.14,triggerId='marc-growth-'+root.closest('.shopify-section').id;
    // Complete the entrance before the section reaches the viewport top; pin only from top:0.
    var pinTrigger=ST.create({id:triggerId+'-pin',trigger:root,pin:stage,start:'top top',end:function(){return '+='+stage.offsetHeight*scrollFactor*(totalDuration-entranceDuration);},anticipatePin:1,onRefreshInit:measure});
    var trigger=ST.create({id:triggerId,trigger:root,start:function(){return 'top '+stage.offsetHeight*scrollFactor*entranceDuration+'px';},end:function(){return pinTrigger.end;},animation:main,scrub:true,invalidateOnRefresh:true});
    ST.refresh();
    return function(){
     counters.forEach(function(value){value.counter.onDestroy();value.el.textContent=value.raw;});
     title.style.removeProperty('--line-color-strength');
     root.classList.remove('dtc-marc-growth--animated');
     root.style.removeProperty('--growth-stage-height');delete root.dataset.growthStage;
    };
   });
  }).catch(function(){delete root.dataset.growthLoading;root.classList.remove('dtc-marc-growth--animated');});
 }
 function boot(scope){if(scope.matches&&scope.matches(selector))mount(scope);scope.querySelectorAll(selector).forEach(mount);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});else boot(document);
 document.addEventListener('shopify:section:load',function(event){boot(event.target);});
 document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll(selector).forEach(function(root){if(root._marcGrowth)root._marcGrowth();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-marc-lawns"] && !Shopify.designMode) return;
  try {
    
(function(){
 function boot(){if(!window.dtcRegisterCarousel)return;window.dtcRegisterCarousel('.dtc-marc-lawns-swiper',function(el){return {slidesPerView:'auto',spaceBetween:10,slidesOffsetBefore:10,slidesOffsetAfter:10,speed:600,loop:true,autoplay:{delay:3000,disableOnInteraction:true},navigation:{prevEl:el.querySelector('.dtc-marc-lawns-prev'),nextEl:el.querySelector('.dtc-marc-lawns-next')},breakpoints:{768:{enabled:false,autoplay:false}}};});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('.dtc-marc-lawns-swiper').forEach(function(el){if(el.swiper)el.swiper.destroy(true,true);});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-marc-story"] && !Shopify.designMode) return;
  try {
    
(function(){
 var reduce=window.matchMedia('(prefers-reduced-motion:reduce)'),items=new Map(),completed=new WeakSet();
 if(!window.IntersectionObserver)return;
 function reset(target){target.classList.remove('is-revealing');target.classList.add('dtc-marc-story-reveal-pending');}
 function reveal(target,trigger){target.classList.remove('dtc-marc-story-reveal-pending');target.classList.add('is-revealing');completed.add(trigger);observer.unobserve(trigger);mindsetObserver.unobserve(trigger);items.delete(trigger);}
 function onEntries(entries){entries.forEach(function(entry){
  var target=items.get(entry.target);
  if(!target)return;
  if(reduce.matches||entry.isIntersecting)reveal(target,entry.target);
 });}
 var observer=new IntersectionObserver(onEntries,{threshold:0});
 function isMindset(trigger){return !!trigger.closest('.dtc-marc-story--mindset');}
 function createMindsetObserver(){return new IntersectionObserver(onEntries,{rootMargin:'0px 0px -'+Math.round(window.innerHeight*.25)+'px 0px',threshold:0});}
 var mindsetObserver=createMindsetObserver();
 window.addEventListener('resize',function(){
  mindsetObserver.disconnect();mindsetObserver=createMindsetObserver();
  items.forEach(function(target,trigger){if(isMindset(trigger))mindsetObserver.observe(trigger);});
 });
 function bind(scope){(scope||document).querySelectorAll('.dtc-marc-story-copy-reveal').forEach(function(trigger){
  if(items.has(trigger)||completed.has(trigger))return;
  var target=trigger.querySelector('.dtc-marc-story-copy-inner');
  if(!target)return;
  if(!reduce.matches)reset(target);
  items.set(trigger,target);(isMindset(trigger)?mindsetObserver:observer).observe(trigger);
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bind(document);});else bind(document);
 reduce.addEventListener('change',function(){if(reduce.matches)items.forEach(function(target,trigger){reveal(target,trigger);});});
 document.addEventListener('shopify:section:load',function(event){bind(event.target);});
 document.addEventListener('shopify:section:unload',function(event){items.forEach(function(target,trigger){
  if(event.target.contains(trigger)){observer.unobserve(trigger);mindsetObserver.unobserve(trigger);items.delete(trigger);}
 });});
})();
(function(){
 var desktop=window.matchMedia('(min-width:768px)'),frame=0;
 function measure(){
  frame=0;
  var bar=document.getElementById('scroll-fix-add-cart');
  document.querySelectorAll('.dtc-marc-story--hero').forEach(function(hero){
   if(!desktop.matches){hero.style.removeProperty('--hero-flow-top');hero.style.removeProperty('--addcart-height');return;}
   var top=Math.max(0,hero.getBoundingClientRect().top+window.scrollY);
   var value=Math.round(top*100)/100+'px';
   if(hero.style.getPropertyValue('--hero-flow-top')!==value)hero.style.setProperty('--hero-flow-top',value);
   hero.style.setProperty('--addcart-height',(bar?bar.offsetHeight:0)+'px');
  });
 }
 function schedule(){if(!frame)frame=window.requestAnimationFrame(measure);}
 if(window.ResizeObserver)new ResizeObserver(schedule).observe(document.body);
 window.addEventListener('resize',schedule);
 window.addEventListener('load',schedule);
 document.addEventListener('shopify:section:load',schedule);
 document.addEventListener('shopify:section:unload',schedule);
 if(document.fonts)document.fonts.ready.then(schedule);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else measure();
})();
(function(){
 var narrow=window.matchMedia('(max-width:767px)'),reduce=window.matchMedia('(prefers-reduced-motion:reduce)'),videos=new Map();
 var initialBuffer=5;
 var bufferEvents=['loadedmetadata','durationchange','loadeddata','progress','canplay','canplaythrough','suspend'];
 function syncLoading(video,state){
  if(!state.progress)return;
  var duration=video.duration,total=0;
  if(Number.isFinite(duration)&&duration>0&&!state.loadedComplete){
   for(var i=0;i<video.buffered.length;i++)total+=Math.max(0,Math.min(duration,video.buffered.end(i))-Math.max(0,video.buffered.start(i)));
   // Sum all buffered ranges: a buffered tail alone does not mean the entire video is loaded.
   var complete=video.buffered.length>0&&video.buffered.start(0)<=.05&&video.buffered.end(video.buffered.length-1)>=duration-.05&&total>=duration-.05;
   state.loadedComplete=complete;
   state.loadedRatio=complete?1:Math.max(state.loadedRatio,Math.min(.999,total/duration));
  }
  var percent=state.loadedComplete?100:Math.min(99,Math.floor(state.loadedRatio*100));
  state.progress.style.setProperty('--video-loaded',String(state.loadedRatio));
  if(percent!==state.percent){state.percent=percent;state.progress.setAttribute('aria-valuenow',String(percent));state.progress.querySelector('.dtc-marc-hero-progress-value').textContent=percent+'%';}
  state.progress.hidden=!state.visible||document.hidden||reduce.matches||state.failed||state.loadedComplete;
 }
 function bufferedAhead(video){
  for(var i=0;i<video.buffered.length;i++)if(video.buffered.start(i)<=video.currentTime+.05&&video.buffered.end(i)>=video.currentTime)return video.buffered.end(i)-video.currentTime;
  return 0;
 }
 function syncVideo(video,state){
  var mode=narrow.matches?'mobile':'desktop';
  var poster=narrow.matches?video.dataset.posterMobile:video.dataset.poster;
  if(poster)video.poster=poster;
  if(!state.visible||document.hidden||reduce.matches){video.pause();if(reduce.matches)video.classList.remove('is-playing');syncLoading(video,state);return;}
  if(state.mode!==mode){
   var template=state.media.querySelector('template[data-marc-video-mode="'+mode+'"]');
   
   video.pause();video.classList.remove('is-playing');if(state.progress)state.progress.hidden=true;video.replaceChildren(template.content.cloneNode(true));
   state.mode=mode;state.failed=false;state.started=false;state.loadedRatio=0;state.loadedComplete=false;state.percent=-1;video.load();syncLoading(video,state);
  }
  syncLoading(video,state);
  if(state.failed)return;
  if(!state.started){
   var needed=Number.isFinite(video.duration)?Math.min(initialBuffer,Math.max(0,video.duration-video.currentTime)):initialBuffer;
   if(video.readyState<3||bufferedAhead(video)+.05<needed)return;
  }
  if(!video.paused)return;
  video.muted=true;
  var playing=video.play();if(playing)playing.catch(function(){if(!state.started){video.classList.remove('is-playing');syncLoading(video,state);}});
 }
 var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){var state=videos.get(entry.target);if(!state)return;state.visible=entry.isIntersecting;syncVideo(entry.target,state);});});
 function bind(scope){(scope||document).querySelectorAll('.dtc-marc-hero-video').forEach(function(video){
  if(videos.has(video))return;
  var state={media:video.closest('.dtc-marc-story-media'),progress:null,loadedRatio:0,loadedComplete:false,percent:-1,visible:false,mode:null,failed:false,started:false};
  state.progress=state.media.querySelector('.dtc-marc-hero-progress');
  state.onPlaying=function(){if(!state.visible||document.hidden||reduce.matches){video.pause();return;}state.started=true;video.classList.add('is-playing');syncLoading(video,state);};
  state.onError=function(){state.failed=true;video.classList.remove('is-playing');if(state.progress)state.progress.hidden=true;};
  state.onBuffer=function(){syncVideo(video,state);};
  video.addEventListener('playing',state.onPlaying);video.addEventListener('error',state.onError);
  bufferEvents.forEach(function(name){video.addEventListener(name,state.onBuffer);});
  videos.set(video,state);observer.observe(video);
 });}
 function sync(){videos.forEach(function(state,video){syncVideo(video,state);});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bind(document);});else bind(document);
 narrow.addEventListener('change',sync);reduce.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
 document.addEventListener('shopify:section:load',function(event){bind(event.target);});
 document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('.dtc-marc-hero-video').forEach(function(video){var state=videos.get(video);if(!state)return;observer.unobserve(video);video.pause();video.removeEventListener('playing',state.onPlaying);video.removeEventListener('error',state.onError);bufferEvents.forEach(function(name){video.removeEventListener(name,state.onBuffer);});video.removeAttribute('src');video.replaceChildren();video.load();videos.delete(video);});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-mpro-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobile = window.matchMedia('(max-width:767px)');
    function paginationFor(el) {
      var pagination = el.parentElement.querySelector('.swiper-pagination');
      var count = Number(el.dataset.slideCount);
      if (!pagination || !count) return;
      pagination.onclick = function (event) {
        var button = event.target.closest('[data-mpro-slide]');
        if (button && el.swiper) el.swiper.slideToLoop(Number(button.dataset.mproSlide));
      };
      return {
        el: pagination,
        type: 'custom',
        renderCustom: function (swiper) {
          var active = swiper.realIndex % count;
          var html = '';
          for (var i = 0; i < count; i++) {
            html += '<button type="button" class="swiper-pagination-bullet' + (i === active ? ' swiper-pagination-bullet-active' : '') + '" data-mpro-slide="' + i + '" aria-label="Go to slide ' + (i + 1) + '"' + (i === active ? ' aria-current="true"' : '') + '></button>';
          }
          return html;
        }
      };
    }

    function init(root) {
      (root || document).querySelectorAll('.dtc-mpro-slider').forEach(function (el) {
        if (el.swiper) return;
        var variant = el.dataset.variant;
        var wrapper = el.closest('.dtc-mpro-slider-wrap');
        var pad = parseFloat(getComputedStyle(el).marginLeft) || 72;
        new DtcSwiper(el, {
          slidesPerView: 'auto', speed: 600, spaceBetween: 10,
          centeredSlides: true, initialSlide: variant === 'navigation' ? 1 : 0, loop: true, grabCursor: true,
          autoplay: { delay: 3000, disableOnInteraction: true },
          keyboard: { enabled: true, onlyInViewport: true },
          pagination: paginationFor(el),
          navigation: { prevEl: wrapper.querySelector('.dtc-mpro-prev'), nextEl: wrapper.querySelector('.dtc-mpro-next') },
          breakpoints: {
            768: {
              spaceBetween: variant === 'scenarios' ? 20 : 30,
              centeredSlides: variant === 'navigation',
              slidesOffsetAfter: variant === 'scenarios' ? pad : 0
            }
          }
        });
      });
    }

    function destroy(root) {
      (root || document).querySelectorAll('.dtc-mpro-slider').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
        var pagination = el.parentElement.querySelector('.swiper-pagination');
        if (pagination) pagination.onclick = null;
      });
    }

    dtcOnSwiper(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
      else init(document);
      document.addEventListener('shopify:section:load', function (event) { init(event.target); });
      document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
      mobile.addEventListener('change', function () { destroy(document); init(document); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-mpro-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var disposers = new WeakMap();

    function navsIn(root) {
      var navs = Array.from(root.querySelectorAll('.dtc-mpro-nav-section'));
      if (root.matches && root.matches('.dtc-mpro-nav-section')) navs.unshift(root);
      return navs;
    }

    function init(root) {
      navsIn(root || document).forEach(function (nav) {
        if (disposers.has(nav)) return;
        var header = document.querySelector('.shopify-section--header');
        var page = nav.closest('.dtc-page');
        var navigation = nav.querySelector('.dtc-mpro-nav');
        var revealAfter = navigation.getAttribute('data-reveal-after');
        var triggerSelector = revealAfter === 'product' ? '.dtc-n8-hero.dtc-on-product' : '.dtc-n8-hero-section';
        var productSection = revealAfter === 'product' && page ? page.querySelector('.shopify-section--main-product') : null;
        var desktop = window.matchMedia('(min-width: 768px)');
        var revealTarget = null;
        var frame = 0;
        var disposed = false;

        function schedule() {
          if (!disposed && !frame) frame = window.requestAnimationFrame(updateOffset);
        }

        function updateOffset() {
          frame = 0;
          var offset = 0;
          if (header) {
            var style = window.getComputedStyle(header);
            var headerState = window.getComputedStyle(document.documentElement).getPropertyValue('--header-is-visible').trim();
            var visible = headerState ? headerState !== '0' : style.visibility !== 'hidden';
            var sticky = style.position === 'sticky' || style.position === 'fixed';
            offset = visible && sticky && style.display !== 'none' ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
          }

          var shown = true;
          if (revealAfter) {
            var nextTarget = (page && page.querySelector(triggerSelector)) || productSection;
            if (nextTarget !== revealTarget) {
              if (revealTarget) sizeObserver.unobserve(revealTarget);
              revealTarget = nextTarget;
              if (revealTarget) sizeObserver.observe(revealTarget);
            }
            if (revealTarget) navigation.setAttribute('data-reveal-after', revealAfter);
            else navigation.removeAttribute('data-reveal-after');
            var triggerPosition = 0;
            if (revealTarget) {
              var targetRect = revealTarget.getBoundingClientRect();
              // The Hero's actual top includes its spacing after the product section.
              triggerPosition = revealAfter === 'product' && revealTarget !== productSection ? targetRect.top : targetRect.bottom;
            }
            shown = desktop.matches && (!revealTarget || triggerPosition <= offset);
            navigation.classList.toggle('is-visible', shown);
            navigation.inert = !shown;
            navigation.setAttribute('aria-hidden', shown ? 'false' : 'true');
          }

          nav.style.setProperty('--mpro-nav-offset', offset + 'px');
          if (page) {
            var navHeight = shown ? navigation.getBoundingClientRect().height : 0;
            page.style.setProperty('--dtc-anchor-offset', (desktop.matches ? offset + navHeight : 0) + 'px');
          }
        }

        var observer = new MutationObserver(schedule);
        if (header) observer.observe(header, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
        var sizeObserver = new ResizeObserver(schedule);
        if (header) sizeObserver.observe(header);
        if (productSection) sizeObserver.observe(productSection);
        sizeObserver.observe(nav);
        sizeObserver.observe(navigation);
        window.addEventListener('resize', schedule);
        if (revealAfter) {
          window.addEventListener('scroll', schedule, { passive: true });
          document.addEventListener('shopify:section:load', schedule);
          document.addEventListener('shopify:section:unload', schedule);
          document.addEventListener('shopify:section:reorder', schedule);
        }
        updateOffset();
        disposers.set(nav, function () {
          disposed = true;
          if (frame) window.cancelAnimationFrame(frame);
          observer.disconnect();
          sizeObserver.disconnect();
          window.removeEventListener('resize', schedule);
          if (revealAfter) {
            window.removeEventListener('scroll', schedule);
            document.removeEventListener('shopify:section:load', schedule);
            document.removeEventListener('shopify:section:unload', schedule);
            document.removeEventListener('shopify:section:reorder', schedule);
          }
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      navsIn(event.target).forEach(function (nav) {
        var dispose = disposers.get(nav);
        if (dispose) dispose();
        var page = nav.closest('.dtc-page');
        if (page) page.style.removeProperty('--dtc-anchor-offset');
        disposers.delete(nav);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-mpro-proof"] && !Shopify.designMode) return;
  try {
    
dtcRegisterCarousel('.dtc-mpro-proof-swiper', function (el) {
  return {
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 10,

      centeredSlides: false,
      initialSlide: 2,

      loop: true,
      // Focus restoration can reposition loop slides without a CSS transition.
      autoplay: { delay: 3000, disableOnInteraction: true, waitForTransition: false },

      breakpoints: {
        768: { spaceBetween: 20, centeredSlides: true },
      },
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-mpro-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobile = window.matchMedia('(max-width:767px)');

    function init(root) {
      (root || document).querySelectorAll('.dtc-mpro-reviews-slider').forEach(function (el) {
        if (!el.swiper) new DtcSwiper(el, {
          slidesPerView: 'auto', spaceBetween: 10, centeredSlides: false, initialSlide: mobile.matches ? 0 : 2,
          breakpoints: { 768: { spaceBetween: 20 } },
          loop: true, grabCursor: true, keyboard: { enabled: true, onlyInViewport: true }
        });
      });
    }

    function destroy(root) {
      (root || document).querySelectorAll('.dtc-mpro-reviews-slider').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
        var pagination = el.querySelector('.swiper-pagination');
        if (pagination) pagination.onclick = null;
      });
    }

    dtcOnSwiper(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
      else init(document);
      document.addEventListener('shopify:section:load', function (event) { init(event.target); });
      document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
      mobile.addEventListener('change', function () { destroy(document); init(document); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-mpro-setup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobile = window.matchMedia('(max-width:767px)');
    function paginationFor(el) {
      var pagination = el.parentElement.querySelector('.dtc-mpro-setup-pagination');
      var count = Number(el.dataset.slideCount);
      if (!pagination || !count) return;
      pagination.onclick = function (event) {
        var button = event.target.closest('[data-mpro-slide]');
        if (button && el.swiper) el.swiper.slideToLoop(Number(button.dataset.mproSlide));
      };
      return {
        el: pagination,
        type: 'custom',
        renderCustom: function (swiper) {
          var active = swiper.realIndex % count;
          var html = '';
          for (var i = 0; i < count; i++) {
            html += '<button type="button" class="swiper-pagination-bullet' + (i === active ? ' swiper-pagination-bullet-active' : '') + '" data-mpro-slide="' + i + '" aria-label="Go to slide ' + (i + 1) + '"' + (i === active ? ' aria-current="true"' : '') + '></button>';
          }
          return html;
        }
      };
    }

    function init(root) {
      if (mobile.matches) return;
      (root || document).querySelectorAll('.dtc-mpro-setup-slider').forEach(function (el) {
        var pad = parseFloat(getComputedStyle(el).marginLeft) || 72;
        if (!el.swiper) new DtcSwiper(el, {
          slidesPerView: 'auto', spaceBetween: 30, slidesOffsetAfter: pad,
          loop: true, grabCursor: true, pagination: paginationFor(el)
        });
      });
    }

    function destroy(root) {
      (root || document).querySelectorAll('.dtc-mpro-setup-slider').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
        var pagination = el.parentElement.querySelector('.dtc-mpro-setup-pagination');
        if (pagination) pagination.onclick = null;
      });
    }

    dtcOnSwiper(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
      else init(document);
      document.addEventListener('shopify:section:load', function (event) { init(event.target); });
      document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
      mobile.addEventListener('change', function () { destroy(document); init(document); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  var media = window.matchMedia('(min-width:768px)');

  function paginationFor(el) {
    var pagination = el.parentElement.querySelector('.swiper-pagination');
    var count = Number(el.dataset.slideCount);
    if (!pagination || !count) return;
    pagination.onclick = function (event) {
      var button = event.target.closest('[data-details-slide]');
      if (button && el.swiper) el.swiper.slideToLoop(Number(button.dataset.detailsSlide));
    };
    return {
      el: pagination,
      type: 'custom',
      renderCustom: function (swiper) {
        var active = swiper.realIndex % count;
        var html = '';
        for (var i = 0; i < count; i++) {
          html += '<button type="button" class="swiper-pagination-bullet' + (i === active ? ' swiper-pagination-bullet-active' : '') + '" data-details-slide="' + i + '" aria-label="Go to slide ' + (i + 1) + '"' + (i === active ? ' aria-current="true"' : '') + '></button>';
        }
        return html;
      }
    };
  }

  function init(root) {
      root.querySelectorAll('.dtc-n8-s10-swiper').forEach(function (el) {
        if (!el.isConnected) return;
        var active = !media.matches;
        if (!active) {
          if (el.swiper) el.swiper.destroy(true, true);
          return;
        }
        if (el.swiper) return;
        new DtcSwiper(el, {
          slidesPerView: 1,
          spaceBetween: 10,
          speed: 1000,
          loop: true,
          watchOverflow: true,
          grabCursor: true,
          autoplay: { delay: 3000, disableOnInteraction: true, waitForTransition: true },
          pagination: paginationFor(el)
        });
      });
  }

  function destroy(root) {
    root.querySelectorAll('.dtc-n8-s10-swiper').forEach(function (el) {
      if (el.swiper) el.swiper.destroy(true, true);
      var pagination = el.parentElement.querySelector('.swiper-pagination');
      if (pagination) pagination.onclick = null;
    });
  }

  dtcOnSwiper(function () {
    function load() { init(document); }
    media.addEventListener('change', function () { destroy(document); init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
    else load();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var desktop = window.matchMedia('(min-width: 768px)');
  var selector = '.dtc-n8-hero:not([allow-transparent-header]):not(.dtc-on-product)';
  var frame = 0;

  function measure() {
    frame = 0;
    document.querySelectorAll(selector).forEach(function (hero) {
      if (!desktop.matches) {
        hero.style.removeProperty('--hero-flow-top');
        return;
      }
      // Flow position includes all header rows and any section above the Hero.
      // Document coordinates keep the height stable when a sticky header hides.
      var top = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
      var value = Math.round(top * 100) / 100 + 'px';
      if (hero.style.getPropertyValue('--hero-flow-top') !== value) {
        hero.style.setProperty('--hero-flow-top', value);
      }
    });
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(measure);
  }

  if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.body);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else measure();
})();

dtcRegisterCarousel('.dtc-n8-hero-swiper', function (el) {
  var hero = el.closest('.dtc-n8-hero');
  var slideCount = el.querySelectorAll('.swiper-slide').length;
  hero.querySelectorAll('.dtc-n8-hero-nav-btn').forEach(function (button) {
    button.hidden = slideCount < 2;
  });
  return {
      loop: true,
      speed: 1000,

      parallax: true,
      autoplay: { delay: 3000, disableOnInteraction: true },
      navigation: {
        prevEl: el.closest('.dtc-n8-hero').querySelector('.dtc-n8-hero-nav-prev'),
        nextEl: el.closest('.dtc-n8-hero').querySelector('.dtc-n8-hero-nav-next'),
      },
      grabCursor: true,
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-less-time"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wide = window.matchMedia('(min-width: 768px)');

  function build(el) {
    var pad = parseFloat(getComputedStyle(el).marginLeft) || 72;

    return {
      loop: true,
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 30,
      slidesOffsetAfter: pad,
      autoplay: { delay: 3000, disableOnInteraction: true },
      pagination: {
        el: el.parentElement.querySelector('.dtc-n8-s7-pagination'),
        clickable: true,
      },
    };
  }

  function sync(root) {
    (root || document).querySelectorAll('.dtc-n8-s7-swiper').forEach(function (el) {
      if (wide.matches && !el.swiper) new DtcSwiper(el, build(el));
      else if (!wide.matches && el.swiper) el.swiper.destroy(true, true);
    });
  }

  dtcOnSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { sync(); });
    } else {
      sync();
    }
    document.addEventListener('shopify:section:load', function (event) { sync(event.target); });
    wide.addEventListener('change', function () { sync(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-proof"] && !Shopify.designMode) return;
  try {
    
function dtcInitProofThumbnails(root) {
  root.querySelectorAll('.dtc-n8-proof-thumb[data-dtc-proof-thumb-fallback]').forEach(function (img) {
    if (img.dataset.dtcProofThumbInitialized) return;
    img.dataset.dtcProofThumbInitialized = 'true';
    var fallback = img.getAttribute('data-dtc-proof-thumb-fallback');

    function useFallback() {
      if (img.hasAttribute('data-dtc-proof-thumb-fallback')) {
        img.removeAttribute('data-dtc-proof-thumb-fallback');
        img.src = fallback;
      } else {
        img.remove();
      }
    }

    function checkThumbnail() {
      // Missing maxres images can return a 120px placeholder with HTTP 200.
      if (img.hasAttribute('data-dtc-proof-thumb-fallback') && img.naturalWidth <= 120) useFallback();
    }

    img.addEventListener('error', useFallback);
    img.addEventListener('load', checkThumbnail);
    // The image may have loaded or failed before the section script runs.
    if (img.complete) {
      if (img.naturalWidth) checkThumbnail();
      else useFallback();
    }
  });
}

dtcRegisterCarousel('.dtc-n8-proof-swiper', function (el) {
  dtcInitProofThumbnails(el);
  return {
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 10,

      centeredSlides: false,
      initialSlide: 2,

      loop: true,
      // Focus restoration can reposition loop slides without a CSS transition.
      autoplay: { delay: 3000, disableOnInteraction: true, waitForTransition: false },

      on: {
        init: function (swiper) {
          function restoreVideoFocus(event) {
            var trigger = event.target.closest('[data-dtc-video]');
            var lightbox = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
            if (!lightbox || lightbox.trigger !== trigger || !lightbox.resumeAutoplay || lightbox.dialog.open) return;
            // Modal focus restoration must not count as a user slide change.
            var scrollOnFocus = swiper.params.a11y.scrollOnFocus;
            swiper.params.a11y.scrollOnFocus = false;
            queueMicrotask(function () {
              if (!swiper.destroyed) swiper.params.a11y.scrollOnFocus = scrollOnFocus;
            });
          }
          swiper.el.addEventListener('focus', restoreVideoFocus, true);
          swiper.once('destroy', function () {
            swiper.el.removeEventListener('focus', restoreVideoFocus, true);
          });
        },
        autoplay: function (swiper) {
          // A skipped loop advance must still schedule the next autoplay tick.
          if (swiper.autoplay.running && !swiper.autoplay.paused) swiper.autoplay.resume();
        }
      },

      breakpoints: {
        768: { spaceBetween: 20, centeredSlides: true },
      },
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-rtk"] && !Shopify.designMode) return;
  try {
    
dtcRegisterCarousel('.dtc-n8-s6-swiper', function (el) {
  var section = el.closest('.dtc-n8-rtk');
  return {
      loop: true,
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 10,
      initialSlide: 1,
      centeredSlides: true,
      slideToClickedSlide: true,
      autoplay: { delay: 3000, disableOnInteraction: true },
      navigation: {
        prevEl: section.querySelector('.dtc-n8-s6-prev'),
        nextEl: section.querySelector('.dtc-n8-s6-next'),
      },
      breakpoints: {
        768: { spaceBetween: 30 },
      },
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-tackles"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wide = window.matchMedia('(min-width: 768px)');

  function build(el) {
    var section = el.closest('.dtc-n8-tackles');
    return {
      loop: true,
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 20,
      centeredSlides: true,
      slideToClickedSlide: true,
      autoplay: { delay: 3000, disableOnInteraction: true },
      navigation: {
        prevEl: section.querySelector('.dtc-n8-s4-prev'),
        nextEl: section.querySelector('.dtc-n8-s4-next'),
      },
    };
  }

  function sync(root) {
    (root || document).querySelectorAll('.dtc-n8-s4-swiper').forEach(function (el) {
      if (wide.matches && !el.swiper) new DtcSwiper(el, build(el));
      else if (!wide.matches && el.swiper) el.swiper.destroy(true, true);
    });
  }

  dtcOnSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { sync(); });
    } else {
      sync();
    }
    document.addEventListener('shopify:section:load', function (event) { sync(event.target); });
    wide.addEventListener('change', function () { sync(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run(nums) {
    var CU = window.countUp && window.countUp.CountUp;
    if (!CU) return;

    nums.forEach(function (n) {
      var w = n.el.getBoundingClientRect().width;
      var fs = parseFloat(getComputedStyle(n.el).fontSize);
      n.el.style.minWidth = w / fs + 'em';
      n.el.textContent = n.prefix + '0' + n.suffix;

      new CU(n.el, n.end, {
        startVal: 0,
        duration: 2,
        decimalPlaces: n.decimals,
        useGrouping: n.grouped,
        prefix: n.prefix,
        suffix: n.suffix,
      }).start();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.dtc-n8-trust').forEach(function (root) {
      if (root.dataset.dtcS9) return;
      root.dataset.dtcS9 = '1';

      var head = root.querySelector('.dtc-n8-s9-head');
      if (!head) return;

      var nums = [];
      root.querySelectorAll('.dtc-n8-is-accent').forEach(function (el) {
        var m = el.textContent.trim().match(/^(\D*)([\d.,]+)(.*)$/);
        if (!m) return;
        var plain = m[2].replace(/,/g, '');
        var end = parseFloat(plain);
        if (isNaN(end)) return;
        nums.push({
          el: el,
          prefix: m[1],
          suffix: m[3],
          end: end,
          decimals: (plain.split('.')[1] || '').length,
          grouped: m[2].indexOf(',') > -1,
        });
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('is-in');
        return;
      }

      var ioNum = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          ioNum.disconnect();
          run(nums);
        },
        { rootMargin: '0px 0px -12% 0px' }
      );

      var ioBadge = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          ioBadge.disconnect();
          root.classList.add('is-in');
        },
        { threshold: 0.4 }
      );

      ioNum.observe(head);

      var badges = root.querySelector('.dtc-n8-s9-badges');
      if (badges) ioBadge.observe(badges);
      else root.classList.add('is-in');
    });
  }

  function boot() {
    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-video-full"] && !Shopify.designMode) return;
  try {
    
(function () {
  var narrow = window.matchMedia('(max-width: 767px)');

  function syncPoster(root) {
    (root || document).querySelectorAll('.dtc-n8-s5-video').forEach(function (video) {
      var next = narrow.matches ? video.dataset.posterMobile : video.dataset.poster;
      if (next && video.poster !== next) video.poster = next;
    });
  }

  function syncSource(root) {
    (root || document).querySelectorAll('.dtc-n8-s5-video').forEach(function (video) {
      if (!video.querySelector('source[data-mode="mobile"]')) return;
      if (!video.dtcSources) video.dtcSources = Array.prototype.slice.call(video.querySelectorAll('source[data-mode]'));
      var want = narrow.matches ? 'mobile' : 'pc';
      if ((video.dataset.srcMode || 'pc') === want) return;
      video.dataset.srcMode = want;
      var wasPlaying = !video.paused;
      video.querySelectorAll('source[data-mode]').forEach(function (s) { s.remove(); });
      video.dtcSources.forEach(function (s) {
        if (s.dataset.mode === want) video.appendChild(s);
      });
      video.load();
      if (wasPlaying) video.play().catch(function () {});
    });
  }

  var HIDE_DELAY = 2000;

  function revealControls(media) {
    if (!media.classList.contains('is-playing')) return;
    media.classList.add('controls-visible');
    clearTimeout(media.dtcHideTimer);
    media.dtcHideTimer = setTimeout(function () {
      media.classList.remove('controls-visible');
    }, HIDE_DELAY);
  }

  function setPlaying(media, on) {
    var video = media.querySelector('video');
    var btn = media.querySelector('.dtc-n8-s5-toggle');

    media.classList.toggle('is-playing', on);
    if (video) {
      if (on) video.play();
      else video.pause();
    }
    if (btn) btn.setAttribute('aria-label', on ? 'Pause video' : 'Play video');

    clearTimeout(media.dtcHideTimer);
    if (on) revealControls(media);
    else media.classList.remove('controls-visible');
  }

  function bind(root) {
    (root || document).querySelectorAll('.dtc-n8-s5-media').forEach(function (media) {
      if (media.dataset.bound) return;
      media.dataset.bound = '1';

      media.addEventListener('click', function () {
        setPlaying(media, !media.classList.contains('is-playing'));
      });

      media.addEventListener('mousemove', function () { revealControls(media); });
      media.addEventListener('mouseleave', function () {
        clearTimeout(media.dtcHideTimer);
        media.classList.remove('controls-visible');
      });

      var video = media.querySelector('video');
      if (video) {
        video.addEventListener('ended', function () { setPlaying(media, false); });
      }
    });
  }

  function init(root) {
    bind(root);
    syncPoster(root);
    syncSource(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  narrow.addEventListener('change', function () { syncPoster(); syncSource(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-n8-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var narrow = window.matchMedia('(max-width: 767px)');
  var videos = new Map();

  function playVisible(video, state) {
    if (!state.visible || document.hidden) {
      video.pause();
      return;
    }
    var mode = narrow.matches && state.media.querySelector('template[data-dtc-video-mode="mobile"]') ? 'mobile' : 'desktop';
    if (state.mode !== mode) {
      video.pause();
      video.replaceChildren(state.media.querySelector('template[data-dtc-video-mode="' + mode + '"]').content.cloneNode(true));
      state.mode = mode;
      video.load();
    }
    video.muted = true;
    var playing = video.play();
    if (playing) playing.catch(function () {});
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      playVisible(entry.target, state);
    });
  });

  function bind(root) {
    (root || document).querySelectorAll('.dtc-n8-s3-video').forEach(function (video) {
      if (videos.has(video)) return;
      var state = {media: video.closest('.dtc-n8-s3-media'), visible: false, mode: null};
      // Autoplay must remain stopped when the browser resumes an offscreen video.
      state.onPlay = function () {
        if (!state.visible || document.hidden) video.pause();
      };
      video.addEventListener('play', state.onPlay);
      videos.set(video, state);
      observer.observe(video);
    });
  }

  function sync() {
    videos.forEach(function (state, video) { playVisible(video, state); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  narrow.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.dtc-n8-s3-video').forEach(function (video) {
      var state = videos.get(video);
      if (!state) return;
      observer.unobserve(video);
      video.pause();
      video.removeEventListener('play', state.onPlay);
      videos.delete(video);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-accessories-service"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5las]';

    const initialiseReveal = (section) => {
      if (!section || section.dataset.m5lasRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5lasRevealInitialised = 'true';

      if (
        !section.querySelector('[data-m5las-reveal]') ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5las--is-visible');
      };

      section.classList.add('m5las--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialize = (section) => {
      initialiseReveal(section);

      if (section.dataset.m5lasInitialized === 'true') {
        return;
      }

      section.dataset.m5lasInitialized = 'true';

      const viewport = section.querySelector('[data-m5las-viewport]');
      const track = section.querySelector('[data-m5las-track]');
      const slides = Array.from(section.querySelectorAll('[data-m5las-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-m5las-dot]'));

      if (!viewport || !track || slides.length < 2) {
        return;
      }

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let autoplayTimer;
      let isPaused = false;
      let isCarouselActive = slides.length > (mobileQuery.matches ? 1 : 2);
      let dragState;

      const getVisibleCount = () => (mobileQuery.matches ? 1 : 2);
      const getMaxIndex = () => Math.max(0, slides.length - getVisibleCount());

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const updatePosition = (shouldAnimate) => {
        track.classList.toggle('m5las--no-transition', !shouldAnimate || reducedMotionQuery.matches);

        if (isCarouselActive) {
          const activeSlide = slides[activeIndex];
          track.style.transform = activeSlide ? `translate3d(${-activeSlide.offsetLeft}px, 0, 0)` : '';
        } else {
          track.style.transform = '';
        }

        updateDots();
      };

      const clearAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      const startAutoplay = () => {
        clearAutoplay();

        if (!mobileQuery.matches || !isCarouselActive || reducedMotionQuery.matches || isPaused || dragState) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          activeIndex = activeIndex >= getMaxIndex() ? 0 : activeIndex + 1;
          updatePosition(true);
        }, 3000);
      };

      const goToSlide = (nextIndex) => {
        if (!isCarouselActive) {
          return;
        }

        activeIndex = Math.min(Math.max(nextIndex, 0), getMaxIndex());
        updatePosition(true);
        startAutoplay();
      };

      const endDrag = (event) => {
        if (!dragState || (event && event.pointerId !== dragState.pointerId)) {
          return;
        }

        const deltaX = (event ? event.clientX : dragState.lastX) - dragState.startX;
        const threshold = Math.max(40, viewport.clientWidth * 0.12);

        if (viewport.hasPointerCapture && viewport.hasPointerCapture(dragState.pointerId)) {
          viewport.releasePointerCapture(dragState.pointerId);
        }

        dragState = undefined;
        viewport.classList.remove('m5las--dragging');
        track.classList.remove('m5las--dragging');
        track.classList.remove('m5las--no-transition');

        if (Math.abs(deltaX) >= threshold) {
          goToSlide(activeIndex + (deltaX < 0 ? 1 : -1));
        } else {
          updatePosition(false);
          startAutoplay();
        }
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!isCarouselActive || (event.pointerType === 'mouse' && event.button !== 0)) {
          return;
        }

        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          lastX: event.clientX,
        };

        clearAutoplay();
        track.classList.add('m5las--no-transition', 'm5las--dragging');
        viewport.classList.add('m5las--dragging');
        viewport.setPointerCapture?.(event.pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) {
          return;
        }

        dragState.lastX = event.clientX;
        const activeSlide = slides[activeIndex];

        if (activeSlide) {
          event.preventDefault();
          const deltaX = event.clientX - dragState.startX;
          track.style.transform = `translate3d(${-activeSlide.offsetLeft + deltaX}px, 0, 0)`;
        }
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
        });
      });

      const handleViewportEnter = () => {
        isPaused = true;
        clearAutoplay();
      };

      const handleViewportLeave = () => {
        isPaused = false;
        startAutoplay();
      };

      viewport.addEventListener('pointerenter', handleViewportEnter);
      viewport.addEventListener('pointerleave', handleViewportLeave);
      viewport.addEventListener('focusin', handleViewportEnter);
      viewport.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!section.contains(document.activeElement)) {
            handleViewportLeave();
          }
        }, 0);
      });

      const handleBreakpointChange = () => {
        isCarouselActive = slides.length > (mobileQuery.matches ? 1 : 2);
        activeIndex = Math.min(activeIndex, getMaxIndex());
        updatePosition(false);
        startAutoplay();
      };

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpointChange);
      } else {
        mobileQuery.addListener(handleBreakpointChange);
      }

      if (reducedMotionQuery.addEventListener) {
        reducedMotionQuery.addEventListener('change', handleBreakpointChange);
      } else {
        reducedMotionQuery.addListener(handleBreakpointChange);
      }

      updatePosition(false);
      startAutoplay();
    };

    const initializeAll = (scope) => {
      if (scope instanceof Element && scope.matches(selector)) {
        initialize(scope);
      }

      scope.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-ai-avoidance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-ai-avoidance]';
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialiseIntroReveal = (section) => {
      if (!section || section.dataset.m5laaIntroRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5laaIntroRevealInitialised = 'true';

      if (!section.querySelector('[data-m5laa-reveal]') || reducedMotionQuery.matches) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5laa--intro-visible');
      };

      section.classList.add('m5laa--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialise = (section) => {
      if (!section) {
        return;
      }

      initialiseIntroReveal(section);

      if (section.dataset.m5laaInitialised === 'true') {
        return;
      }

      const scrollArea = section.querySelector('[data-m5laa-scroll]');
      const sticky = section.querySelector('[data-m5laa-sticky]');

      if (!scrollArea || !sticky) {
        return;
      }

      section.dataset.m5laaInitialised = 'true';

      let isTicking = false;
      const holdDistance = 100;

      const updateProgress = () => {
        isTicking = false;

        if (reducedMotionQuery.matches) {
          section.style.setProperty('--m5laa-progress', '1');
          return;
        }

        const scrollBounds = scrollArea.getBoundingClientRect();
        const scrollRange = Math.max(scrollArea.offsetHeight - sticky.offsetHeight, 1);
        const stickyBounds = sticky.getBoundingClientRect();
        const scrollDistance = Math.min(scrollRange, Math.max(0, stickyBounds.top - scrollBounds.top));
        const revealRange = Math.max(scrollRange - holdDistance * 2, 1);
        const progress = Math.min(1, Math.max(0, (scrollDistance - holdDistance) / revealRange));

        section.style.setProperty('--m5laa-progress', progress.toFixed(4));
      };

      const requestProgressUpdate = () => {
        if (isTicking) {
          return;
        }

        isTicking = true;
        window.requestAnimationFrame(updateProgress);
      };

      const markVisible = () => {
        section.classList.add('m5laa--is-visible');
      };

      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                markVisible();
                visibilityObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.05 }
        );

        visibilityObserver.observe(section);
      } else {
        markVisible();
      }

      window.addEventListener('scroll', requestProgressUpdate, { passive: true });
      window.addEventListener('resize', requestProgressUpdate);

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(requestProgressUpdate);
        resizeObserver.observe(scrollArea);
        resizeObserver.observe(sticky);
      }

      if (reducedMotionQuery.addEventListener) {
        reducedMotionQuery.addEventListener('change', requestProgressUpdate);
      } else {
        reducedMotionQuery.addListener(requestProgressUpdate);
      }

      requestProgressUpdate();
    };

    const initialiseAll = (scope) => {
      if (scope instanceof Element && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAll(document);
      });
    } else {
      initialiseAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-care-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-care-banner]';
    const observers = new WeakMap();

    const prepareStats = (section) => {
      const heading = section.querySelector('[data-m5lcb-heading]');
      const line = heading && (heading.querySelector('p') || heading);

      if (!line || line.dataset.m5lcbStatsReady === 'true') {
        return [];
      }

      const nodes = Array.from(line.childNodes);
      const fragment = document.createDocumentFragment();
      const accents = [];
      let stat = null;
      let label = null;

      nodes.forEach((node) => {
        const isAccent = node.nodeType === Node.ELEMENT_NODE && node.matches('strong, b, em, i');

        if (isAccent) {
          stat = document.createElement('span');
          stat.className = 'm5lidar-care-banner__stat';
          node.classList.add('m5lidar-care-banner__accent');
          stat.append(node);
          label = document.createElement('span');
          label.className = 'm5lidar-care-banner__stat-label';
          stat.append(label);
          fragment.append(stat);
          accents.push(node);
          return;
        }

        if (label) {
          label.append(node);
        } else if (node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== '') {
          fragment.append(node);
        }
      });

      if (accents.length > 0) {
        line.replaceChildren(fragment);
        line.classList.add('m5lidar-care-banner__stats');
        line.querySelectorAll('.m5lidar-care-banner__stat-label').forEach((statLabel) => {
          statLabel.innerHTML = statLabel.innerHTML.trim();
        });
      }

      line.dataset.m5lcbStatsReady = 'true';
      return accents;
    };

    const prepareCounter = (element) => {
      const finalText = element.textContent.trim();
      const match = finalText.match(/-?\d+(?:[.,]\d+)?/);

      if (!match) {
        return null;
      }

      const numberToken = match[0];
      const target = Number(numberToken.replace(',', '.'));

      if (!Number.isFinite(target)) {
        return null;
      }

      const decimalMark = numberToken.includes(',') ? ',' : '.';
      const decimalPart = numberToken.split(decimalMark)[1];
      const precision = decimalPart ? decimalPart.length : 0;
      const prefix = finalText.slice(0, match.index);
      const suffix = finalText.slice(match.index + numberToken.length);

      element.setAttribute('aria-label', finalText);
      element.textContent = `${prefix}${precision > 0 ? (0).toFixed(precision).replace('.', decimalMark) : '0'}${suffix}`;

      return {
        element,
        finalText,
        target,
        prefix,
        suffix,
        precision,
        decimalMark
      };
    };

    const animateCounter = (counter) => {
      const duration = 1400;
      let startTime = null;

      const draw = (time) => {
        if (startTime === null) {
          startTime = time;
        }

        const progress = Math.min((time - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 4);
        const value = counter.target * eased;
        const formatted = counter.precision > 0
          ? value.toFixed(counter.precision).replace('.', counter.decimalMark)
          : String(Math.round(value));

        counter.element.textContent = `${counter.prefix}${formatted}${counter.suffix}`;

        if (progress < 1) {
          window.requestAnimationFrame(draw);
          return;
        }

        counter.element.textContent = counter.finalText;
        counter.element.classList.add('m5lcb--counter-complete');
      };

      window.requestAnimationFrame(draw);
    };

    const initialise = (section) => {
      if (!section || section.dataset.m5lcbRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5lcbRevealInitialised = 'true';
      const accents = prepareStats(section);
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion) {
        return;
      }

      const counters = accents.map(prepareCounter).filter(Boolean);

      const reveal = () => {
        section.classList.add('m5lcb--is-visible');
        counters.forEach(animateCounter);
      };

      section.classList.add('m5lcb--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
              observers.delete(section);
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(section);
      observers.set(section, observer);
    };

    const initialiseIn = (scope) => {
      if (scope instanceof Element && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseIn(document);
      }, { once: true });
    } else {
      initialiseIn(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector(selector);
      const observer = section && observers.get(section);

      if (observer) {
        observer.disconnect();
        observers.delete(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-coverage-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-coverage-accordion]';

    const initialiseReveal = (section) => {
      if (!section || section.dataset.m5lcaRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5lcaRevealInitialised = 'true';

      if (
        !section.querySelector('[data-m5lca-reveal]') ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5lca--is-visible');
      };

      section.classList.add('m5lca--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialise = (section) => {
      if (!section) {
        return;
      }

      initialiseReveal(section);

      if (section.dataset.m5lcaInitialised === 'true') {
        return;
      }

      section.dataset.m5lcaInitialised = 'true';

      const panels = Array.from(section.querySelectorAll('[data-m5lca-panel]'));
      const desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

      if (!panels.length) {
        return;
      }

      const activate = (selectedPanel) => {
        panels.forEach((panel) => {
          const isActive = panel === selectedPanel;
          const trigger = panel.querySelector('[data-m5lca-trigger]');

          panel.classList.toggle('is-active', isActive);

          if (trigger) {
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        });
      };

      panels.forEach((panel) => {
        const trigger = panel.querySelector('[data-m5lca-trigger]');

        if (trigger) {
          trigger.addEventListener('click', () => {
            activate(panel);
          });
        }

        panel.addEventListener('mouseenter', () => {
          if (desktopHoverQuery.matches) {
            activate(panel);
          }
        });
      });

      activate(panels.find((panel) => panel.classList.contains('is-active')) || panels[0]);
    };

    const initialiseIn = (scope) => {
      if (scope.matches && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    const start = () => {
      initialiseIn(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-feature-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-feature-carousel]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const initialiseReveal = (section) => {
      if (!section || section.dataset.m5fcRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5fcRevealInitialised = 'true';

      if (
        !section.querySelector('[data-m5fc-reveal]') ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5fc--is-visible');
      };

      section.classList.add('m5fc--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialise = (section) => {
      if (!section) {
        return;
      }

      initialiseReveal(section);

      if (section.dataset.m5fcInitialised === 'true') {
        return;
      }

      const viewport = section.querySelector('[data-m5fc-viewport]');
      const track = section.querySelector('[data-m5fc-track]');
      const slides = track ? Array.from(track.querySelectorAll('[data-m5fc-slide]')) : [];
      const dots = Array.from(section.querySelectorAll('[data-m5fc-dot]'));

      if (!viewport || !track || !slides.length) {
        return;
      }

      section.dataset.m5fcInitialised = 'true';

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let cloneCount = 1;
      let isCarouselActive = false;
      let isTransitioning = false;
      let shouldResetPosition = false;
      let autoplayTimer;
      let transitionTimer;
      let dragState;

      const clearAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const clearTransition = () => {
        window.clearTimeout(transitionTimer);
        isTransitioning = false;
        shouldResetPosition = false;
      };

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;

          dot.classList.toggle('is-active', isActive);

          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setTransition = (enabled) => {
        track.classList.toggle('m5fc--no-transition', !enabled);
      };

      const positionTrack = (trackIndex, shouldAnimate) => {
        const targetSlide = track.children[trackIndex];

        if (!targetSlide) {
          return;
        }

        setTransition(shouldAnimate);
        track.style.transform = `translate3d(${-targetSlide.offsetLeft}px, 0, 0)`;

        if (!shouldAnimate) {
          track.getBoundingClientRect();
          setTransition(true);
        }
      };

      const removeClones = () => {
        track.querySelectorAll('[data-m5fc-clone]').forEach((clone) => clone.remove());
      };

      const createClone = (slide) => {
        const clone = slide.cloneNode(true);

        clone.dataset.m5fcClone = 'true';
        clone.removeAttribute('data-m5fc-slide');
        clone.setAttribute('aria-hidden', 'true');

        Array.from(clone.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) {
            clone.removeAttribute(attribute.name);
          }
        });

        return clone;
      };

      const startAutoplay = () => {
        clearAutoplay();

        if (!isCarouselActive || reduceMotion || dragState) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          move(1);
        }, 3000);
      };

      const completeTransition = () => {
        if (!isTransitioning) {
          return;
        }

        if (shouldResetPosition) {
          shouldResetPosition = false;
          positionTrack(cloneCount + activeIndex, false);
        }

        isTransitioning = false;
        window.clearTimeout(transitionTimer);
      };

      const move = (direction) => {
        if (!isCarouselActive || isTransitioning) {
          return;
        }

        const previousIndex = activeIndex;
        activeIndex = (activeIndex + direction + slides.length) % slides.length;

        const wrapsForward = direction > 0 && previousIndex === slides.length - 1;
        const wrapsBackward = direction < 0 && previousIndex === 0;
        const targetIndex = wrapsForward
          ? cloneCount + slides.length
          : wrapsBackward
            ? cloneCount - 1
            : cloneCount + activeIndex;

        shouldResetPosition = wrapsForward || wrapsBackward;
        isTransitioning = true;
        updateDots();
        positionTrack(targetIndex, true);
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(completeTransition, 700);
      };

      const goTo = (nextIndex) => {
        if (!isCarouselActive || isTransitioning || nextIndex === activeIndex) {
          return;
        }

        activeIndex = nextIndex;
        shouldResetPosition = false;
        isTransitioning = true;
        updateDots();
        positionTrack(cloneCount + activeIndex, true);
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(completeTransition, 700);
      };

      const endDrag = (event) => {
        if (!dragState || (event && event.pointerId !== dragState.pointerId)) {
          return;
        }

        const deltaX = (event ? event.clientX : dragState.lastX) - dragState.startX;
        const threshold = Math.max(40, viewport.clientWidth * 0.12);

        if (viewport.hasPointerCapture && viewport.hasPointerCapture(dragState.pointerId)) {
          viewport.releasePointerCapture(dragState.pointerId);
        }

        dragState = undefined;
        viewport.classList.remove('m5fc--dragging');
        track.classList.remove('m5fc--dragging');
        setTransition(true);

        if (Math.abs(deltaX) >= threshold) {
          move(deltaX < 0 ? 1 : -1);
        } else if (!isTransitioning) {
          positionTrack(cloneCount + activeIndex, false);
        }

        startAutoplay();
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!isCarouselActive || (event.pointerType === 'mouse' && event.button !== 0)) {
          return;
        }

        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          lastX: event.clientX,
        };

        clearAutoplay();
        clearTransition();
        setTransition(false);
        viewport.classList.add('m5fc--dragging');
        track.classList.add('m5fc--dragging');
        viewport.setPointerCapture?.(event.pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) {
          return;
        }

        dragState.lastX = event.clientX;
        const activeSlide = track.children[cloneCount + activeIndex];

        if (activeSlide) {
          event.preventDefault();
          const deltaX = event.clientX - dragState.startX;
          track.style.transform = `translate3d(${-activeSlide.offsetLeft + deltaX}px, 0, 0)`;
        }
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      const rebuild = () => {
        clearAutoplay();
        clearTransition();
        removeClones();

        cloneCount = Math.min(mobileQuery.matches ? 2 : 3, slides.length);
        isCarouselActive = slides.length > (mobileQuery.matches ? 1 : 2);
        activeIndex = Math.min(activeIndex, slides.length - 1);
        section.classList.toggle('m5fc--static', !isCarouselActive);

        if (isCarouselActive) {
          const leadingClones = slides.slice(slides.length - cloneCount);
          const leadingFragment = document.createDocumentFragment();

          leadingClones.forEach((slide) => leadingFragment.appendChild(createClone(slide)));
          track.insertBefore(leadingFragment, track.firstChild);
          slides.slice(0, cloneCount).forEach((slide) => track.appendChild(createClone(slide)));
          positionTrack(cloneCount + activeIndex, false);
        } else {
          track.style.transform = '';
        }

        updateDots();
        startAutoplay();
      };

      track.addEventListener('transitionend', (event) => {
        if (event.target === track && event.propertyName === 'transform') {
          completeTransition();
        }
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const nextIndex = Number(dot.dataset.m5fcDot);

          if (Number.isInteger(nextIndex)) {
            goTo(nextIndex);
            startAutoplay();
          }
        });
      });

      section.addEventListener('pointerenter', clearAutoplay);
      section.addEventListener('pointerleave', startAutoplay);
      section.addEventListener('focusin', clearAutoplay);
      section.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!section.contains(document.activeElement)) {
            startAutoplay();
          }
        });
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          if (isCarouselActive) {
            positionTrack(cloneCount + activeIndex, false);
          }
        });

        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', () => {
          if (isCarouselActive) {
            positionTrack(cloneCount + activeIndex, false);
          }
        });
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', rebuild);
      } else {
        mobileQuery.addListener(rebuild);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearAutoplay();
        } else {
          startAutoplay();
        }
      });

      window.requestAnimationFrame(rebuild);
    };

    const initialiseIn = (scope) => {
      if (scope.matches && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    const start = () => {
      initialiseIn(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-imgs-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lic]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialiseReveal = (section) => {
      if (!section || section.dataset.m5licRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5licRevealInitialised = 'true';

      if (
        !section.querySelector('[data-m5lic-reveal]') ||
        reducedMotionQuery.matches
      ) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5lic--is-visible');
      };

      section.classList.add('m5lic--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialise = (section) => {
      if (!section) {
        return;
      }

      initialiseReveal(section);

      if (section.dataset.m5licInitialised === 'true') {
        return;
      }

      const comparison = section.querySelector('[data-m5lic-comparison]');
      const divider = section.querySelector('[data-m5lic-divider]');

      if (!comparison || !divider) {
        return;
      }

      section.dataset.m5licInitialised = 'true';

      let position = 50;
      let activePointerId = null;
      let hintTimerId = null;
      let hintFrameId = null;
      let hintObserver = null;
      let hintToken = 0;
      let userInteracted = false;
      const infoCardEdgeThreshold = 18;

      const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

      const updatePosition = (nextPosition) => {
        position = clamp(nextPosition, 0, 100);
        const roundedPosition = Math.round(position);

        comparison.style.setProperty('--m5lic-position', `${position}%`);
        comparison.classList.toggle('m5lic--left-card-hidden', position <= infoCardEdgeThreshold);
        comparison.classList.toggle('m5lic--right-card-hidden', position >= 100 - infoCardEdgeThreshold);
        divider.setAttribute('aria-valuenow', String(roundedPosition));
        divider.setAttribute('aria-valuetext', `${roundedPosition}%`);
      };

      const cancelHint = () => {
        userInteracted = true;
        hintToken += 1;

        if (hintTimerId !== null) {
          window.clearTimeout(hintTimerId);
          hintTimerId = null;
        }

        if (hintFrameId !== null) {
          window.cancelAnimationFrame(hintFrameId);
          hintFrameId = null;
        }

        if (hintObserver) {
          hintObserver.disconnect();
          hintObserver = null;
        }
      };

      const runHint = () => {
        if (userInteracted || activePointerId !== null || reducedMotionQuery.matches) {
          return;
        }

        const token = hintToken;
        const segments = [
          { target: 38, duration: 650 },
          { target: 62, duration: 900 },
          { target: 50, duration: 650 },
        ];
        let segmentIndex = 0;
        let segmentStart = position;

        const runSegment = () => {
          if (token !== hintToken || userInteracted || activePointerId !== null) {
            hintFrameId = null;
            return;
          }

          const segment = segments[segmentIndex];
          const startedAt = performance.now();

          const tick = (timestamp) => {
            if (token !== hintToken || userInteracted || activePointerId !== null) {
              hintFrameId = null;
              return;
            }

            const progress = clamp((timestamp - startedAt) / segment.duration, 0, 1);
            const easedProgress = progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            updatePosition(segmentStart + (segment.target - segmentStart) * easedProgress);

            if (progress < 1) {
              hintFrameId = window.requestAnimationFrame(tick);
              return;
            }

            segmentStart = segment.target;
            segmentIndex += 1;

            if (segmentIndex < segments.length) {
              runSegment();
            } else {
              hintFrameId = null;
            }
          };

          hintFrameId = window.requestAnimationFrame(tick);
        };

        runSegment();
      };

      const scheduleHint = () => {
        if (reducedMotionQuery.matches) {
          return;
        }

        const startTimer = () => {
          if (userInteracted || hintTimerId !== null) {
            return;
          }

          hintTimerId = window.setTimeout(() => {
            hintTimerId = null;
            runHint();
          }, 3000);
        };

        if (!('IntersectionObserver' in window)) {
          startTimer();
          return;
        }

        hintObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              if (hintObserver) {
                hintObserver.disconnect();
              }
              hintObserver = null;
              startTimer();
            }
          },
          { threshold: 0.35 }
        );

        hintObserver.observe(comparison);
      };

      const updateOrientation = () => {
        divider.setAttribute('aria-orientation', mobileQuery.matches ? 'vertical' : 'horizontal');
      };

      const positionFromPointer = (event) => {
        const bounds = comparison.getBoundingClientRect();

        if (!bounds.width || !bounds.height) {
          return;
        }

        const nextPosition = mobileQuery.matches
          ? ((event.clientY - bounds.top) / bounds.height) * 100
          : ((event.clientX - bounds.left) / bounds.width) * 100;

        updatePosition(nextPosition);
      };

      const stopDragging = (event) => {
        if (event && activePointerId !== event.pointerId) {
          return;
        }

        if (activePointerId !== null && divider.hasPointerCapture && divider.hasPointerCapture(activePointerId)) {
          divider.releasePointerCapture(activePointerId);
        }

        activePointerId = null;
        divider.classList.remove('is-dragging');
      };

      divider.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        event.preventDefault();
        cancelHint();
        activePointerId = event.pointerId;
        divider.setPointerCapture(event.pointerId);
        divider.classList.add('is-dragging');
        positionFromPointer(event);
      });

      divider.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) {
          return;
        }

        event.preventDefault();
        positionFromPointer(event);
      });

      divider.addEventListener('pointerup', stopDragging);
      divider.addEventListener('pointercancel', stopDragging);
      divider.addEventListener('lostpointercapture', () => stopDragging());

      divider.addEventListener('keydown', (event) => {
        const step = 5;
        let nextPosition = position;

        if (event.key === 'Home') {
          nextPosition = 0;
        } else if (event.key === 'End') {
          nextPosition = 100;
        } else if (mobileQuery.matches && event.key === 'ArrowUp') {
          nextPosition -= step;
        } else if (mobileQuery.matches && event.key === 'ArrowDown') {
          nextPosition += step;
        } else if (!mobileQuery.matches && event.key === 'ArrowLeft') {
          nextPosition -= step;
        } else if (!mobileQuery.matches && event.key === 'ArrowRight') {
          nextPosition += step;
        } else {
          return;
        }

        event.preventDefault();
        cancelHint();
        updatePosition(nextPosition);
      });

      const handleBreakpointChange = () => {
        updateOrientation();
        updatePosition(position);
      };

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpointChange);
      } else {
        mobileQuery.addListener(handleBreakpointChange);
      }

      updateOrientation();
      updatePosition(position);
      scheduleHint();
    };

    const initialiseIn = (scope) => {
      if (scope.matches && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    const start = () => {
      initialiseIn(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-obstacle-avoidance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-obstacle-avoidance]';
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const initialiseReveal = (section) => {
      if (!section || section.dataset.m5oaRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5oaRevealInitialised = 'true';
      const revealItems = section.querySelectorAll('[data-m5oa-reveal]');
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!revealItems.length || reduceMotion) {
        return;
      }

      section.classList.add('m5oa--motion-ready');

      if (!('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('m5oa--is-visible'));
        return;
      }

      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('m5oa--is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    };

    const buildCarousel = (section) => {
      const viewport = section.querySelector('[data-m5oa-viewport]');

      if (!viewport || !window.DtcSwiper || viewport.swiper) {
        return;
      }

      const slideCount = Number(viewport.dataset.slideCount || 0);

      new DtcSwiper(viewport, {
        loop: true,
        slidesPerView: 'auto',
        speed: 600,
        spaceBetween: 30,
        centeredSlides: true,
        initialSlide: slideCount > 1 ? 1 : 0,
        slideToClickedSlide: true,
        grabCursor: true,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          prevEl: section.querySelector('[data-m5oa-previous]'),
          nextEl: section.querySelector('[data-m5oa-next]'),
        },
      });
    };

    const destroyCarousel = (section) => {
      const viewport = section.querySelector('[data-m5oa-viewport]');

      if (viewport?.swiper) {
        viewport.swiper.destroy(true, true);
      }
    };

    const sync = (scope) => {
      const root = scope || document;
      const sections = [];

      if (root.matches && root.matches(selector)) {
        sections.push(root);
      }

      root.querySelectorAll?.(selector).forEach((section) => sections.push(section));

      sections.forEach((section) => {
        initialiseReveal(section);

        if (desktopQuery.matches) {
          buildCarousel(section);
        } else {
          destroyCarousel(section);
        }
      });
    };

    const start = () => sync(document);

    const ready = () => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }

      document.addEventListener('shopify:section:load', (event) => sync(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.matches?.(selector)) {
          destroyCarousel(event.target);
        }
      });

      const handleBreakpointChange = () => sync(document);
      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', handleBreakpointChange);
      } else {
        desktopQuery.addListener(handleBreakpointChange);
      }
    };

    if (typeof window.dtcOnSwiper === 'function') {
      window.dtcOnSwiper(ready);
    } else {
      ready();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-reasons-choose"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-reasons-choose]';

    const initialise = (section) => {
      if (!section || section.dataset.m5rcInitialised === 'true') {
        return;
      }

      section.dataset.m5rcInitialised = 'true';

      const revealItems = section.querySelectorAll('[data-m5rc-reveal]');
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!revealItems.length || reduceMotion) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5rc--is-visible');
      };

      section.classList.add('m5rc--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialiseIn = (scope) => {
      if (scope.matches && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    const start = () => {
      initialiseIn(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-smart-living"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-smart-living]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const initialise = (section) => {
      if (!section || section.dataset.m5slInitialised === 'true') {
        return;
      }

      const viewport = section.querySelector('[data-m5sl-viewport]');
      const track = section.querySelector('[data-m5sl-track]');
      const slides = track ? Array.from(track.querySelectorAll('[data-m5sl-slide]')) : [];
      const dots = Array.from(section.querySelectorAll('[data-m5sl-dot]'));
      const revealItems = section.querySelectorAll('[data-m5sl-reveal]');

      if (!viewport || !track || !slides.length) {
        return;
      }

      section.dataset.m5slInitialised = 'true';

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let isCarouselActive = false;
      let isTransitioning = false;
      let shouldResetPosition = false;
      let autoplayTimer;
      let transitionTimer;
      let dragState;

      const clearAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const clearTransition = () => {
        window.clearTimeout(transitionTimer);
        isTransitioning = false;
        shouldResetPosition = false;
      };

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;

          dot.classList.toggle('is-active', isActive);

          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setTransition = (enabled) => {
        track.classList.toggle('m5sl--no-transition', !enabled);
      };

      const positionTrack = (trackIndex, shouldAnimate) => {
        const targetSlide = track.children[trackIndex];

        if (!targetSlide) {
          return;
        }

        setTransition(shouldAnimate);
        track.style.transform = `translate3d(${-targetSlide.offsetLeft}px, 0, 0)`;

        if (!shouldAnimate) {
          track.getBoundingClientRect();
          setTransition(true);
        }
      };

      const removeClones = () => {
        track.querySelectorAll('[data-m5sl-clone]').forEach((clone) => clone.remove());
      };

      const createClone = (slide) => {
        const clone = slide.cloneNode(true);

        clone.dataset.m5slClone = 'true';
        clone.removeAttribute('data-m5sl-slide');
        clone.setAttribute('aria-hidden', 'true');

        Array.from(clone.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) {
            clone.removeAttribute(attribute.name);
          }
        });

        return clone;
      };

      const startAutoplay = () => {
        clearAutoplay();

        if (!isCarouselActive || reduceMotion || dragState) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          moveForward();
        }, 3000);
      };

      const completeTransition = () => {
        if (!isTransitioning) {
          return;
        }

        if (shouldResetPosition) {
          shouldResetPosition = false;
          positionTrack(1 + activeIndex, false);
        }

        isTransitioning = false;
        window.clearTimeout(transitionTimer);
      };

      const moveForward = () => {
        if (!isCarouselActive || isTransitioning) {
          return;
        }

        const wrapsForward = activeIndex === slides.length - 1;
        activeIndex = wrapsForward ? 0 : activeIndex + 1;
        shouldResetPosition = wrapsForward;
        isTransitioning = true;
        updateDots();
        positionTrack(wrapsForward ? slides.length + 1 : 1 + activeIndex, true);
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(completeTransition, 700);
      };

      const goTo = (nextIndex) => {
        if (!isCarouselActive || isTransitioning || nextIndex === activeIndex) {
          return;
        }

        const wrapsForward = activeIndex === slides.length - 1 && nextIndex === 0;
        activeIndex = nextIndex;
        shouldResetPosition = wrapsForward;
        isTransitioning = true;
        updateDots();
        positionTrack(wrapsForward ? slides.length + 1 : 1 + activeIndex, true);
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(completeTransition, 700);
      };

      const endDrag = (event) => {
        if (!dragState || (event && event.pointerId !== dragState.pointerId)) {
          return;
        }

        const deltaX = (event ? event.clientX : dragState.lastX) - dragState.startX;
        const threshold = Math.max(40, viewport.clientWidth * 0.12);

        if (viewport.hasPointerCapture && viewport.hasPointerCapture(dragState.pointerId)) {
          viewport.releasePointerCapture(dragState.pointerId);
        }

        dragState = undefined;
        viewport.classList.remove('m5sl--dragging');
        track.classList.remove('m5sl--dragging');
        setTransition(true);

        if (Math.abs(deltaX) >= threshold) {
          const nextIndex = deltaX < 0
            ? (activeIndex + 1) % slides.length
            : (activeIndex - 1 + slides.length) % slides.length;

          goTo(nextIndex);
        } else if (!isTransitioning) {
          positionTrack(1 + activeIndex, false);
        }

        startAutoplay();
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!isCarouselActive || (event.pointerType === 'mouse' && event.button !== 0)) {
          return;
        }

        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          lastX: event.clientX,
        };

        clearAutoplay();
        clearTransition();
        setTransition(false);
        viewport.classList.add('m5sl--dragging');
        track.classList.add('m5sl--dragging');
        viewport.setPointerCapture?.(event.pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) {
          return;
        }

        dragState.lastX = event.clientX;
        const activeSlide = track.children[1 + activeIndex];

        if (activeSlide) {
          event.preventDefault();
          const deltaX = event.clientX - dragState.startX;
          track.style.transform = `translate3d(${-activeSlide.offsetLeft + deltaX}px, 0, 0)`;
        }
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      const rebuild = () => {
        clearAutoplay();
        clearTransition();
        removeClones();

        isCarouselActive = mobileQuery.matches && slides.length > 1;
        activeIndex = Math.min(activeIndex, slides.length - 1);

        if (isCarouselActive) {
          track.insertBefore(createClone(slides[slides.length - 1]), track.firstChild);
          track.appendChild(createClone(slides[0]));
          positionTrack(1 + activeIndex, false);
        } else {
          track.style.transform = '';
        }

        updateDots();
        startAutoplay();
      };

      track.addEventListener('transitionend', (event) => {
        if (event.target === track && event.propertyName === 'transform') {
          completeTransition();
        }
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const nextIndex = Number(dot.dataset.m5slDot);

          if (Number.isInteger(nextIndex)) {
            goTo(nextIndex);
            startAutoplay();
          }
        });
      });

      section.addEventListener('pointerenter', clearAutoplay);
      section.addEventListener('pointerleave', startAutoplay);
      section.addEventListener('focusin', clearAutoplay);
      section.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!section.contains(document.activeElement)) {
            startAutoplay();
          }
        });
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          if (isCarouselActive) {
            positionTrack(1 + activeIndex, false);
          }
        });

        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', () => {
          if (isCarouselActive) {
            positionTrack(1 + activeIndex, false);
          }
        });
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', rebuild);
      } else {
        mobileQuery.addListener(rebuild);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearAutoplay();
        } else {
          startAutoplay();
        }
      });

      if (!revealItems.length || reduceMotion) {
        revealItems.forEach((item) => item.classList.add('m5sl--is-visible'));
      } else {
        section.classList.add('m5sl--motion-ready');

        if ('IntersectionObserver' in window) {
          const revealObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('m5sl--is-visible');
                  revealObserver.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.18 }
          );

          revealItems.forEach((item) => revealObserver.observe(item));
        } else {
          revealItems.forEach((item) => item.classList.add('m5sl--is-visible'));
        }
      }

      window.requestAnimationFrame(rebuild);
    };

    const initialiseIn = (scope) => {
      if (scope.matches && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    const start = () => {
      initialiseIn(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5lidar-what-in-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-m5lidar-what-in-box]';

    const initialise = (section) => {
      if (!section || section.dataset.m5lwbRevealInitialised === 'true') {
        return;
      }

      section.dataset.m5lwbRevealInitialised = 'true';

      if (
        !section.querySelector('[data-m5lwb-reveal]') ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        return;
      }

      const reveal = () => {
        section.classList.add('m5lwb--is-visible');
      };

      section.classList.add('m5lwb--motion-ready');

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    const initialiseIn = (scope) => {
      if (scope instanceof Element && scope.matches(selector)) {
        initialise(scope);
      }

      scope.querySelectorAll(selector).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseIn(document);
      }, { once: true });
    } else {
      initialiseIn(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseIn(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
